/**
 * Labstep
 *
 * @module components/File/VideoPlayer
 * @desc Component to play video files inline
 */

import { CachedFileURLProvider } from 'labstep-web/containers/File/GetURL/Cached';
import React from 'react';
import styles from './styles.module.scss';
import type { FileVideoPlayerProps } from './types';

export const FileVideoPlayer: React.FC<FileVideoPlayerProps> =
  React.memo(
    ({
      file,
      controls = true,
      autoPlay = false,
      muted = false,
      style = {},
    }) => {
      return (
        <div className={styles.container}>
          <CachedFileURLProvider file={file}>
            {({ url }: { url: string }) => (
              <video
                key={file.guid} // Use file GUID as stable key to prevent reloading on re-renders
                controls={controls}
                autoPlay={autoPlay}
                muted={muted}
                preload="metadata"
                style={{
                  width: '100%',
                  maxHeight: '400px',
                  ...style,
                }}
              >
                <source src={url} type={file.mime_type} />
                Your browser does not support the video tag.
              </video>
            )}
          </CachedFileURLProvider>
        </div>
      );
    },
  );
